import { h } from "preact";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
}));

export default function DpeC({ nb }) {
    const classes = useStyles();

    return (
        <svg width="173px" height="240px" viewBox="0 0 346 477" version="1.1">
            <title>DPE</title>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="DPE" transform="translate(1.000000, 0.000000)">
                    <g id="mire-C" transform="translate(147.000000, 177.000000)">
                        <rect id="Rectangle" stroke="#000000" stroke-width="4" x="114" y="7" width="82" height="46"></rect>
                        <line
                            x1="112.5"
                            y1="30.5"
                            x2="0.5"
                            y2="30.5"
                            id="Line"
                            stroke="#000000"
                            stroke-width="4"
                            stroke-linecap="square"
                            stroke-dasharray="15"
                        ></line>
                        <text id="XXX" font-family="SourceSansRoman-Semibold, Source Sans Variable" font-size="48" font-weight="500" fill="#000000">
                            <tspan x="116.062607" y="47">
                                {nb}
                            </tspan>
                        </text>
                    </g>
                    <g fill-rule="nonzero">
                        <text id="Consommation-énergétique" fill="#000000" font-family="Arial-BoldMT, Arial" font-size="24" font-weight="bold">
                            <tspan x="0" y="22">
                                Consommation énergétique
                            </tspan>
                        </text>
                        <text id="en-kWh/m²/an" fill="#000000" font-family="Arial-BoldMT, Arial" font-size="24" font-weight="bold">
                            <tspan x="0" y="52">
                                en kWh/m²/an
                            </tspan>
                        </text>
                        <polygon
                            id="Path"
                            stroke="#000000"
                            fill="#008000"
                            points="7.10542736e-15 62 7.10542736e-15 112 90 112 115.355339 87 90 62"
                        ></polygon>
                        <polygon id="Path" stroke="#000000" fill="#00FF00" points="0 122 0 172 110 172 135.355339 147 110 122"></polygon>
                        <polygon id="Path" stroke="#000000" fill="#80FF00" points="0 182 0 232 130 232 155.355339 207 130 182"></polygon>
                        <polygon id="Path" stroke="#000000" fill="#FFFF00" points="0 242 0 292 150 292 175.355339 267 150 242"></polygon>
                        <polygon id="Path" stroke="#000000" fill="#FF8000" points="0 302 0 352 170 352 195.355339 327 170 302"></polygon>
                        <polygon id="Path" stroke="#000000" fill="#FF8040" points="0 362 0 412 190 412 215.355339 387 190 362"></polygon>
                        <polygon id="Path" stroke="#000000" fill="#FF0000" points="0 422 0 472 210 472 235.355339 447 210 422"></polygon>
                        <text id="A" fill="#000000" font-family="ArialMT, Arial" font-size="36" font-weight="normal">
                            <tspan x="70" y="100">
                                A
                            </tspan>
                        </text>
                        <text id="B" fill="#000000" font-family="ArialMT, Arial" font-size="36" font-weight="normal">
                            <tspan x="90" y="160">
                                B
                            </tspan>
                        </text>
                        <text id="C" fill="#000000" font-family="ArialMT, Arial" font-size="36" font-weight="normal">
                            <tspan x="110" y="220">
                                C
                            </tspan>
                        </text>
                        <text id="D" fill="#000000" font-family="ArialMT, Arial" font-size="36" font-weight="normal">
                            <tspan x="130" y="280">
                                D
                            </tspan>
                        </text>
                        <text id="E" fill="#000000" font-family="ArialMT, Arial" font-size="36" font-weight="normal">
                            <tspan x="150" y="340">
                                E
                            </tspan>
                        </text>
                        <text id="F" fill="#000000" font-family="ArialMT, Arial" font-size="36" font-weight="normal">
                            <tspan x="170" y="400">
                                F
                            </tspan>
                        </text>
                        <text id="G" fill="#000000" font-family="ArialMT, Arial" font-size="36" font-weight="normal">
                            <tspan x="190" y="460">
                                G
                            </tspan>
                        </text>
                        <text id="≤-50" fill="#000000" font-family="ArialMT, Arial" font-size="20" font-weight="normal">
                            <tspan x="10" y="95">
                                &lt; 70
                            </tspan>
                        </text>
                        <text id="51-à-90" fill="#000000" font-family="ArialMT, Arial" font-size="20" font-weight="normal">
                            <tspan x="10" y="155">
                                70 à 110
                            </tspan>
                        </text>
                        <text id="91-à-150" fill="#000000" font-family="ArialMT, Arial" font-size="20" font-weight="normal">
                            <tspan x="10" y="215">
                                110 à 180
                            </tspan>
                        </text>
                        <text id="151-à-230" fill="#000000" font-family="ArialMT, Arial" font-size="20" font-weight="normal">
                            <tspan x="10" y="275">
                                180 à 250
                            </tspan>
                        </text>
                        <text id="231-à-330" fill="#000000" font-family="ArialMT, Arial" font-size="20" font-weight="normal">
                            <tspan x="10" y="335">
                                250 à 330
                            </tspan>
                        </text>
                        <text id="331-à-450" fill="#000000" font-family="ArialMT, Arial" font-size="20" font-weight="normal">
                            <tspan x="10" y="395">
                                330 à 420
                            </tspan>
                        </text>
                        <text id="&gt;-450" fill="#000000" font-family="ArialMT, Arial" font-size="20" font-weight="normal">
                            <tspan x="10" y="455">
                                &gt; 420
                            </tspan>
                        </text>
                    </g>
                </g>
            </g>
        </svg>
    );
}
